import type { ShapeData } from '@/lib/shapes/types/shape-data'
import {
  getBottomBoundary,
  getLeftBoundary,
  getRightBoundary,
  getShapeChromeScreenRect,
  getTopBoundary,
} from '@/lib/editor/floating-canvas-chrome-bounds'

import { GAP, TH, TW } from '../constants/toolbar-dimensions'

export function computeTextOnPathToolbarPos(
  shape: ShapeData,
  scale: number,
  canvasRect: DOMRect
): { x: number; y: number } {
  const {
    left: sl,
    top: st,
    right: sr,
    bottom: sb,
  } = getShapeChromeScreenRect(shape, scale, canvasRect)
  const cx = (sl + sr) / 2
  const cy = (st + sb) / 2
  const topBoundary = getTopBoundary()
  const bottomBoundary = getBottomBoundary()
  const leftBoundary = getLeftBoundary()
  const rightBoundary = getRightBoundary()
  const clampX = (v: number) => Math.max(leftBoundary + 8, Math.min(rightBoundary - TW - 8, v))
  const clampY = (v: number) => Math.max(topBoundary, Math.min(bottomBoundary - TH - 8, v))

  // Same fallback order as the crop/node-edit toolbars: above, below, left, right.
  if (st - TH - GAP >= topBoundary) return { x: clampX(cx - TW / 2), y: clampY(st - TH - GAP) }
  if (sb + GAP + TH <= bottomBoundary - 8) return { x: clampX(cx - TW / 2), y: clampY(sb + GAP) }
  if (sl - TW - GAP >= leftBoundary + 8) return { x: clampX(sl - TW - GAP), y: clampY(cy - TH / 2) }

  return { x: clampX(sr + GAP), y: clampY(cy - TH / 2) }
}
